angular.module('unica_transfer.transfer_services')

.factory('TransferCreateService', function($http, getBaseApiURL) {

	var transferCreateService = {};

	transferCreateService.create = function(transferData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/transfer/create',
			data: transferData
		}).then(function(result) {

			if ( result ) {
				return result.data.transfer;
			}

		});
	};

	return transferCreateService;

})
;